export const isPresent = <U extends any>(a: U | null | undefined): a is U => {
    if (a === null || a === undefined) return false;
    return true;
};

export default isPresent;
